import styled from 'styled-components';
import { Link } from 'react-router-dom';

type CardProps = {
  image?: string;
};

export const ContentCard = styled.div`
  grid-area: ctos;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  height: fit-content;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

export const Card = styled.div<CardProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  gap: 15px;
  border-radius: 8px;
  width: 48%;

  @media (max-width: 1260px) {
    width: 45%;
  }
`;

export const CardImage = styled.div<CardProps>`
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;

  display: block;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  height: 100%;
  width: 100%;
  filter: brightness(0.4);
  border-radius: 8px;
`;

export const Icon = styled.div`
  margin-top: 16px;
  margin-left: 13px;
  z-index: 2;

  & svg {
    min-width: 22px;
    min-height: 22px;
    color: #fff;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  line-height: 1;
  color: #fff;
  width: 125px;
  margin-bottom: 16px;
  margin-left: 13px;
  z-index: 2;
`;

export const Button = styled(Link)`
  position: absolute;
  bottom: 16px;
  right: 11px;
  padding: 10px;
  display: flex;
  align-items: center;
  font-size: 10px;
  line-height: 1;
  background-color: ${({ theme }) => theme.colors.blue};
  color: #fff;
  border-radius: 4px;
  z-index: 2;
  gap: 5px;

  &:hover {
    text-decoration: none;
    color: #fff;
  }

  & svg {
    min-height: 7px;
    min-width: 7px;
  }

  @media (max-width: 768px) {
    padding: 6px;
    right: 6px;
    top: 12px;
    bottom: initial;

    span {
      display: none;
    }
  }
`;
